module.exports = "//public.zight.com/packs/media/images/annotate/tools-history-back-disabled-537186f64dd85fe73a04d1f72bc00926.svg";